// extracted by mini-css-extract-plugin
module.exports = {"pill":"portal-system-status_component_pill__OKaUv","dot":"portal-system-status_component_dot__S8JrH"};